import { gql } from "@apollo/client";

const SAVE_PARAMETROS_CONTROL_CLINICO_AE = gql`
    mutation saveVisitaParametrosControlClinicoAE($input: AddVisitaParametrosControlClinicoInput!, $idTeleEnfermeria: Int!){
        saveVisitaParametrosControlClinicoAE(input: $input, idTeleEnfermeria: $idTeleEnfermeria) {
            idParametrosControlClinico
        }
    }
`;

export default SAVE_PARAMETROS_CONTROL_CLINICO_AE;

export const adaptAddVisitaParametrosControlClinicoInput = (data) => ({
  idTeleEnfermeria: data?.idTeleEnfermeriaAE,
  input: {
    idParametrosControlClinico: data?.idParametrosControlClinico || 0,
    comoSintioDias: data?.comoSintioDias,
    modifAnimoActividad: data?.modifAnimoActividad,
    sienteDolor: !!data?.sienteDolor,
    tuvoFiebre: !!data?.tuvoFiebre,
    presion: data?.presion,
    situacionClinicaAvisar: data?.situacionClinicaAvisar,
    comoSienteAbdomen: data?.comoSienteAbdomen,
    nauseas: !!data?.nauseas,
    vomito: !!data?.vomito,
    diarrea: !!data?.diarrea,
    constipacion: !!data?.constipacion,
    controlGlucemia: data?.controlGlucemia,
    llamadaMedicoMotivo: data?.llamadaMedicoMotivo,
    dolorDescripcion: data?.dolorDescripcion
  }
});